import { inject, Injectable } from "@angular/core";
import { ViewportScreenSize, ViewportStore } from "../store/viewport.store";
import { BreakpointObserver } from "@angular/cdk/layout";
import { SCREEN_SIZE } from "../constants/viewport-sizes";
import { MatDialogConfig } from "@angular/material/dialog";

@Injectable({
	providedIn: "root",
})
export class ViewportService {
	private viewportStore = inject(ViewportStore);
	private breakpointObserver = inject(BreakpointObserver);

	public initializeViewportObserver(): void {
		this.viewportStore.setScreenSize(ViewportScreenSize.DESKTOP);

		const smallScreenBreakpoint = `(width <= ${SCREEN_SIZE.SMALL}px)`;
		const mediumScreenBreakpoint = `(width > ${SCREEN_SIZE.SMALL}px) and (width <= ${SCREEN_SIZE.MEDIUM}px)`;
		const largeScreenBreakpoint = `(width > ${SCREEN_SIZE.MEDIUM}px) and (width <= ${SCREEN_SIZE.LARGE}px)`;
		this.breakpointObserver
			.observe([smallScreenBreakpoint, mediumScreenBreakpoint, largeScreenBreakpoint])
			.subscribe((result) => {
				if (result.breakpoints[smallScreenBreakpoint]) {
					this.viewportStore.setScreenSize(ViewportScreenSize.SMALL);
					return;
				}
				if (result.breakpoints[mediumScreenBreakpoint]) {
					this.viewportStore.setScreenSize(ViewportScreenSize.MEDIUM);
					return;
				}
				if (result.breakpoints[largeScreenBreakpoint]) {
					this.viewportStore.setScreenSize(ViewportScreenSize.LARGE);
					return;
				}
				this.viewportStore.setScreenSize(ViewportScreenSize.DESKTOP);
			});
	}

	public getMobileDialogSize(): MatDialogConfig {
		if (this.viewportStore.isMediumOrSmallerScreen()) {
			return {
				width: '98vw',
				maxWidth: '98vw',
				maxHeight: '80vh',
			}
		}
		return {};
	}
}
